import React from 'react';
import PaginationComponent from '../../Shared/Pagination';
import Breadcrumb from '../../Shared/BreadCumb';
import {BUTTON_LINE_ICON} from '../../Shared/Constants';
import { MagnifyingGlassCircleIcon, 
PlusCircleIcon, 
PencilIcon, 
XMarkIcon
 } from '@heroicons/react/20/solid';
 import { Field, Switch } from '@headlessui/react'

class ForcesList extends React.Component {
    
    BreadcrumbPages = [
        { name: 'Administracion', href: '#', current: false },
        { name: 'Lista de Cuerpos Policiales', href: '#', current: true },
    ]

    constructor(props) {
            super(props);    
            this.state = {
                dialog: false,
                enabled: false,
            };
    }

    openByDialog = () => {
        this.props.openDialog();
    }

    searchInput = () => {
        return (
            <div>
                <div className="relative mt-2 rounded-md shadow-sm">
                    <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                        <MagnifyingGlassCircleIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
                    </div>
                    <input
                        id="email"
                        name="email"
                        type="text"
                        placeholder="Buscar"
                        className="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-emerald-600 sm:text-sm/6"
                        />
                </div>
            </div>
        )
    }

    render() {
        return(
            <div className="px-4 sm:px-6 lg:px-8">
                <div style={{marginBottom:10}}>
                    <Breadcrumb pages={this.BreadcrumbPages}/>
                </div>
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h1 className="text-white font-semibold text-gray-900">.</h1>
                    </div>
                    <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                        <button
                            onClick={() => {this.openByDialog()}}
                            type="button"
                            className={BUTTON_LINE_ICON}>
                        <PlusCircleIcon aria-hidden="true" className="h-5 w-5 text-white-400"/>
                            NUEVO CUERPO POLICIAL
                        </button>
                    </div>
                </div>
            
                <div className="sm:flex sm:items-center">
                {this.searchInput()}
                </div>
                    <div className="mt-8 flow-root">
                        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                            <table className="min-w-full divide-y divide-gray-300">
                                <thead className="bg-gray-50">
                                <tr>
                                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                    Codigo
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                    Nombre
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                    Creado 
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                    Estado 
                                    </th>
                                    <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                        <span className="sr-only">Edit</span>
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200 bg-white">
                                    <tr key={1}>
                                       <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            KEE39D
                                        </td> 
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            Fuerza de ejemplo 1
                                        </td> 
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            2023-12-25
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            <Field className="flex items-center">
                                                <Switch
                                                    checked={this.state.enabled}
                                                    onChange={()=>{this.setState({enabled:!this.state.enabled})}}
                                                    className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-emerald-600 focus:ring-offset-2 data-[checked]:bg-emerald-600"
                                                >
                                                    <span
                                                    aria-hidden="true"
                                                    className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                                    />
                                                </Switch>
                                            </Field>
                                        </td>
                                        <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                            <div style={{display:'flex', flexDirection:'row'}}>
                                                <div style={{paddingLeft:10}}>
                                                    <button 
                                                        onClick={() => {}}
                                                        type="button"
                                                        className="rounded-full bg-emerald-600 p-1 text-white shadow-sm hover:bg-emerald-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600"
                                                        >
                                                        <PencilIcon aria-hidden="true" className="h-5 w-5" />
                                                    </button>
                                                </div>
                                                <div style={{paddingLeft:10}}>
                                                    <button 
                                                        onClick={() => {}}
                                                        type="button"
                                                        className="rounded-full bg-emerald-600 p-1 text-white shadow-sm hover:bg-emerald-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600">
                                                        <XMarkIcon aria-hidden="true" className="h-5 w-5" />
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <PaginationComponent />
                            </div>
                        </div>
                        </div>
                    </div>

                </div>
        )
    }
}

export default ForcesList;